import axios from 'axios';

import { isDefined } from '@/common/utils/utils';
import { modules } from '@/common/utils/modules';
import StorageService from './storage.service';
import store from '@/store';
import { LOGOUT } from '@/store/actions/auth.actions';
import router from '@/router';

const http = axios.create();

export const getError = (response) => {
  if (isDefined(response.data) && isDefined(response.data.errors)) {
    const errors = response.data.errors;

    if (Array.isArray(errors)) {
      return errors[0];
    }

    return errors;
  }

  return 'Something went wrong';
};

http.interceptors.response.use(
  (response) => {
    const headers = response.headers;

    if (isDefined(headers.authorization)) {
      StorageService.setItem(StorageService.KEYS.ACCESS_TOKEN, headers.authorization.replace('Bearer ', ''));
    }

    return response;
  },
  (error) => {
    const nonRedirectUrls = [
        '/api/auth/login'
    ];

    const url = new URL(error.request.responseURL);

    if (!nonRedirectUrls.includes(url.pathname) && error.response.status === 401) {
      store.dispatch(LOGOUT)
          .then(() => router.push({name: 'home'}));
    }

    return Promise.reject(error);
  }
);

export const HttpService = {
  getDefaultHeaders() {
    let headers = {
      'content-type': 'application/json',
      'X-API-Key': process.env.VUE_APP_ADMIN_API_KEY
    };

    const token = StorageService.getItem(StorageService.KEYS.ACCESS_TOKEN);

    if (isDefined(token)) {
      headers = {
        ...headers, ...{
          'Authorization': `Bearer ${token}`
        }
      };
    }

    return headers;
  },

  httpPost(url, data) {
    const headers = this.getDefaultHeaders();
    const moduleId = Object.keys(modules).find(key => modules[key] === process.env.VUE_APP_MODULE);

    return http.post(url, { ...data, moduleId: moduleId }, {headers: headers})
      .then(response => response.data.data)
      .catch(error => this.formatError(error))
  },

  httpPut(url, data) {
    const headers = this.getDefaultHeaders();

    return http.put(url, data, {headers: headers})
      .then(response => response.data.data)
      .catch(error => this.formatError(error))
  },

  httpGet(url, params) {
    const headers = this.getDefaultHeaders();
    const moduleId = Object.keys(modules).find(key => modules[key] === process.env.VUE_APP_MODULE);

    return http.get(url, {headers: headers, params: {...params, moduleId: moduleId}})
      .then(response => response.data.data)
      .catch(error => this.formatError(error))
  },

  formatError(error) {
    return Promise.reject({
      status: error.response.status,
      data: error.response.data
    });
  }
};
